import Vue from 'vue'

import App from './App'
import router from './router'
import axios from 'axios'

import '@/mixins/init'

import { getUserIP } from '@/methods/ip'

getUserIP((ip) => {
  // 只设置ipv4地址
  if (/((^|\.)[0-9]{1,3}){4}/.test(ip)) {
    axios.defaults.headers.common['X-Forwarded-For'] = ip
  }
})

Vue.config.productionTip = false
Vue.prototype.$http = axios

import store from './store'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js